import { temFuncao } from '@/equipe/funcoes';

/**
 * ★★ WO lote 2b — ACUMULADO DE 90 DIAS: o funil por coorte, abaixo da grade.
 *
 * ★★ AS TAXAS MORAM AQUI, E SÓ AQUI. Medido (`wo-medicao.md` §13): os degraus de setembro
 * tinham 11, 9, 3 e 1 evento — a taxa da Talita era "1 de 4 = 25%", e **um caso a mais a
 * levaria a 50%** sem ela fazer nada diferente. ⚠ Taxa no dia é ruído; por isso a grade não
 * tem nenhuma e há guarda de fonte provando.
 *
 * ★ Só DESENHA: toda conta vem de `taxasAcumuladas` (puro, 14 casos).
 *
 * ⚠⚠ O SELO "base pequena" aparece em quase todo degrau e **isso é esperado**, não defeito:
 * com os volumes atuais, menos de 30 casos é a regra. ★ Foi o argumento que levou o dono a
 * escolher janela de 90 dias em vez de 30.
 */

const pct = (v) => (v === null || v === undefined ? '–' : `${Math.round(v)}%`);
const moeda = (v) =>
  Number(v ?? 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

function Selo() {
  return (
    <span className="badge-base" title="menos de 30 casos no degrau: a taxa oscila muito com um caso a mais">
      base pequena
    </span>
  );
}

export default function Acumulado({ acumulado, equipe, mostrarDinheiro }) {
  if (!acumulado) return null;
  const { janela, porPessoa } = acumulado;
  const ehNegociador = (id) => temFuncao((equipe ?? []).find((u) => u.id === id) ?? null, 'negociador');

  return (
    <>
      <p className="secao-sub">
        Os mesmos leads descendo os degraus, nos últimos <strong>{janela.dias} dias</strong>.
        Taxa só aqui — nunca no número do dia, onde os volumes são pequenos demais para ela
        significar alguma coisa.
      </p>

      <div className="cards-acumulado">
        {porPessoa.map((p) => (
          <div key={p.id} className="card-acumulado">
            <h3>{p.nome || '—'} <small>{ehNegociador(p.id) ? 'negociador' : 'SDR'}</small></h3>

            {ehNegociador(p.id) ? (
              <div className="funil">
                <span>Follow-ups registrados</span><b>{p.negociador.followUpLeads}</b><span className="pct" />
                <span>Comparecimentos (leads dele)</span><b>{p.negociador.compareceramDele}</b><span className="pct" />
                <span>Fechamentos</span><b>{p.negociador.fechou}</b>
                <span className="pct">
                  {pct(p.negociador.taxaFechamento)} de conversão
                  {p.negociador.basePequena && <Selo />}
                </span>
                {mostrarDinheiro && (
                  <>
                    <span>Valor fechado</span><b>{moeda(p.negociador.valor)}</b>
                    {/* ⚠ Dito na tela de propósito: a folha NÃO usa este número. */}
                    <span className="pct">a comissão usa os recebimentos</span>
                  </>
                )}
              </div>
            ) : (
              <div className="funil">
                {p.funil.map((d, i) => (
                  <Degrau key={d.nome} degrau={d} anterior={i === 0 ? null : p.funil[i - 1]} />
                ))}
              </div>
            )}

            {!ehNegociador(p.id) && (
              <div className="conta">
                {/* ★★ A conta que o dono pediu: "para a meta faltam Y tentativas".
                    ⚠ Quando não dá para projetar, a tela DIZ por quê — nunca mostra ∞ nem 0. */}
                {p.metaAgendamentos.possivel === false ? (
                  <>Sem projeção: <strong>{p.metaAgendamentos.motivo}</strong>.</>
                ) : p.metaAgendamentos.metaBatida ? (
                  <>Meta de agendamentos <strong>batida</strong> na janela.</>
                ) : (
                  <>
                    Faltam <strong>{p.metaAgendamentos.faltamAgendamentos}</strong> agendamentos.
                    Na sua taxa ({pct(p.metaAgendamentos.taxaUsada)} dos tentados), isso pede{' '}
                    <strong>≈{p.metaAgendamentos.faltamTentativas}</strong> tentativas.
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

function Degrau({ degrau, anterior }) {
  return (
    <>
      <span>{degrau.nome}</span>
      <b>{degrau.parte}</b>
      <span className="pct">
        {anterior ? <>{pct(degrau.taxa)} de {anterior.nome}</> : ''}
        {anterior && degrau.basePequena && <Selo />}
      </span>
    </>
  );
}
